import { Link } from "react-router-dom";
import { useContext } from "react";
import { MobileContext } from "../../providers/MobileContext";
import styles from "./Footer.module.scss";
import logo from "../../Assets/Images/logo01.png";
import footer_icon_1 from "../../Assets/Images/footer_icon_1.png";
import footer_icon_2 from "../../Assets/Images/footer_icon_2.png";
import footer_icon_3 from "../../Assets/Images/footer_icon_3.png";
import Wrapper from "../Layout/Wrapper";

const Footer = () => {
  const isMobile = useContext(MobileContext);

  return (
    <div className={styles.footer_wrapper}>
      <Wrapper>
        <div className={styles.footer_logo_wrapper}>
          <img src={logo} alt="헬스경향 로고 이미지" />
        </div>
        <div
          className={styles.f_top}
          style={{ flexDirection: isMobile ? "column" : "row" }}
        >
          <div className={styles.f_top_left}>
            <div className={styles.text_wrapper}>
              {isMobile ? (
                <>
                  <div className={styles.text_row}>
                    <div className={styles.text_item}>
                      법인명: 주식회사 헬스경향
                    </div>
                    <div className={styles.text_item}>
                      주소: 서울시 종로구 새문안로 38, 6층
                    </div>
                  </div>
                  <div className={styles.text_row}>
                    <div className={styles.text_item}>
                      청소년보호책임자: 조창연
                    </div>
                    <div className={styles.text_item}>
                      등록번호: 서울 아 2289
                    </div>
                  </div>
                  <div className={styles.text_row}>
                    <div className={styles.text_item}>등록일: 2013-01-10</div>
                    <div className={styles.text_item}>발행일: 2013-01-18</div>
                    <div className={styles.text_item}>발행편집인: 조창연</div>
                  </div>
                </>
              ) : (
                <>
                  <div className={styles.text_row}>
                    <div className={styles.text_item}>
                      법인명: 주식회사 헬스경향
                    </div>
                    <div className={styles.text_item}>
                      주소: 서울시 종로구 새문안로 38, 6층
                    </div>
                    <div className={styles.text_item}>
                      청소년보호책임자: 조창연
                    </div>
                  </div>
                  <div className={styles.text_row}>
                    <div className={styles.text_item}>
                      등록번호: 서울 아 2289
                    </div>
                    <div className={styles.text_item}>등록일: 2013-01-10</div>
                    <div className={styles.text_item}>발행일: 2013-01-18</div>
                    <div className={styles.text_item}>발행편집인: 조창연</div>
                  </div>
                </>
              )}
            </div>
            <div
              className={styles.bottom_text}
              style={{ paddingTop: isMobile ? "2rem" : "0" }}
            >
              헬스경향은 한국신문윤리위원회의 신문윤리강령, 신문윤리실천요강,
              신문광고윤리강령, 신문광고윤리실천요강을 준수하고 있습니다.
            </div>
          </div>
          <div
            className={styles.f_top_right}
            style={{ paddingTop: isMobile ? "2rem" : "0" }}
          >
            <a
              href="mailto:desk@k-health.com"
              className={styles.icon_wrapper}
              style={{ justifyContent: isMobile ? "left" : "right" }}
            >
              <img src={footer_icon_1} alt="메일주소 아이콘" />
              <p>desk@k-health.com</p>
            </a>
            <a href="tel:02-3701-1582" className={styles.icon_wrapper}>
              <img src={footer_icon_2} alt="전화 아이콘" />
              <p>02-3701-1582</p>
            </a>
            <a className={styles.icon_wrapper}>
              <img src={footer_icon_3} alt="팩스 아이콘" />
              <p>02-6272-1580</p>
            </a>
          </div>
        </div>
        <div
          className={styles.f_bottom}
          style={{
            gridTemplateColumns: isMobile ? "unset" : "repeat(2, 1fr)",
          }}
        >
          <div
            className={styles.f_bottom_left}
            style={{ order: isMobile ? "1" : "0" }}
          >
            Copyright ⓒ 2024 헬스경향. All Rights Reserved.
          </div>
          <div
            className={styles.f_bottom_right}
            style={{
              order: isMobile ? "0" : "1",
              textAlign: isMobile ? "left" : "right",
            }}
          >
            <Link to="/service">이용약관</Link>
            <Link to="/policy">개인정보처리방침</Link>
          </div>
        </div>
      </Wrapper>
    </div>
  );
};

export default Footer;
